import { get, post, PersonalDetailsUrls } from '@mobi/account/Utils'
import { StreetTypeSuggestions, SuburbStateSuggestions } from '@mobi/api-types'
import { AddressSplitResult } from '../Hooks/useSplitAddress'

export function searchStreetTypes(search: string) {
  return get<StreetTypeSuggestions>(PersonalDetailsUrls.streeTypeList(search))
}

export function searchSuburbStatePostcodes(search: string) {
  return get<SuburbStateSuggestions>(PersonalDetailsUrls.suburbList(search))
}

export function splitAddress(address: string): Promise<AddressSplitResult> {
  return post<{ address: string }, AddressSplitResult>(PersonalDetailsUrls.splitAddress(), {
    address,
  })
}
